<footer class="py-4 bg-dark text-white-50" id="sticky-footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <small>
          <span i18n i18n-matTooltip matTooltip="Version {{version}}">Copyright &copy; {{year}} </span>&nbsp;<a routerLink="/">{{siteTitle}}</a> -
          <a [routerLink]="['/privacy-policy']" i18n>Privacy policy</a> -
          <a [routerLink]="['/imprint']" i18n>Imprint</a> -
          <a [routerLink]="['/support']" i18n>Support</a> -
          <a [href]="tocDownloadLink" i18n target="toc">Terms and conditions </a>
        </small>
      </div>
    </div>
  </div>
</footer>
